import useCreate from "./hooks/useCreate";
import schemaJson from "./schema/SchemaJsonSync.json";
import UISchemaJson from "./schema/UISchemaSync.json";
import { Sites } from "data/utils/globals";
import { SchemaData } from "./hooks/types";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { CreateGql } from "./queries/create";

function Create() {
  return (
    <GenericMethods.Create<SchemaData, CreateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath="/"
      useCreate={useCreate}
      buttonSaveLabel="Sync"
      template={{
        schemaJson: schemaJson,
        UISchema: UISchemaJson,
      }}
    />
  );
}

export default Create;
